/*
 * UMW fix — Aug 18 2026
 * Security/privacy fix: any <a target="_blank"> link should carry
 * rel="noopener noreferrer" so the new tab cannot access window.opener
 * and the Referer header isn't leaked to the destination site.
 * Most links on this store are set correctly via Page/Article/Product
 * content, but two are injected by the theme/apps and can't be edited
 * that way: the Judge.me review-count badge link (homepage) and the
 * theme's "Powered by Shopify" footer link. This script catches those
 * — and any other target="_blank" link injected by an app in the
 * future — without needing a hardcoded list of URLs.
 * Existing rel tokens (e.g. "nofollow") are preserved; only the missing
 * noopener/noreferrer tokens are appended.
 */
(function () {
  var processed = new WeakSet();

  function patchLink(a) {
    if (!a || processed.has(a)) return;
    if (!a.tagName || a.tagName !== 'A') return;
    if (a.getAttribute('target') !== '_blank') return;

    processed.add(a);

    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    var changed = false;
    if (rel.indexOf('noopener') === -1) {
      rel.push('noopener');
      changed = true;
    }
    if (rel.indexOf('noreferrer') === -1) {
      rel.push('noreferrer');
      changed = true;
    }
    if (changed) {
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function scanForLinks(root) {
    if (!root || !root.querySelectorAll) return;
    var links = root.querySelectorAll('a[target="_blank"]');
    for (var i = 0; i < links.length; i++) {
      patchLink(links[i]);
    }
  }

  // Catch links already in the DOM
  document.addEventListener('DOMContentLoaded', function () {
    scanForLinks(document);
  });
  // In case this script runs after DOMContentLoaded already fired
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scanForLinks(document);
  }

  // Judge.me and other apps inject links asynchronously — watch for them
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue; // element nodes only
        if (node.tagName === 'A') {
          patchLink(node);
        } else {
          scanForLinks(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
